/**
 * Configuração de colunas do relatório (sidebar Colunas e dropdown Buscar por).
 * Fonte única para lista de campos.
 */

import {
  CalendarDays,
  Users,
  FileDigit,
  Tag,
  CheckCircle2,
  CalendarCheck,
  Wrench,
  Building2,
  AlertCircle,
  FileText,
  Package,
  Hash,
  MapPin,
  UserCheck,
  Activity,
  BookOpen,
  Clock,
  Gauge,
  Phone,
  Mail,
  RotateCcw,
} from 'lucide-react';

/** IDs de colunas excluídos do dropdown "Buscar por" do filtro (permanecem em Colunas). */
export const FILTER_EXCLUDED_IDS = [
  'abertura',
  'fechamento',
  'contadorA4Pb',
  'contadorA4Cor',
  'contadorDig',
  'contadorA3Pb',
  'contadorA3Cor',
  'obsDefeito',
  'horaInicio',
  'horaFim',
  'deslocamento',
  'telefone1',
  'telefone2',
  'whatsapp',
  'email',
  'laudo',
  'retornos',
  'ultimoRetorno',
  'ciclo',
  'reincidencia',
];

export const COLUMNS_CONFIG = [
  { id: 'os', label: 'OS', icon: FileDigit },
  { id: 'tipo', label: 'Tipo', icon: Tag },
  { id: 'tipoOs', label: 'Tipo de OS', icon: Tag },
  { id: 'abertura', label: 'Abertura', icon: CalendarDays },
  { id: 'empresa', label: 'Empresa', icon: Building2 },
  { id: 'codEmpresa', label: 'Empresa (cód.)', icon: Building2 },
  { id: 'cliente', label: 'Cliente', icon: Users },
  { id: 'fantasia', label: 'Fantasia', icon: Users },
  { id: 'grupoEconomico', label: 'Grupo econômico', icon: Building2 },
  { id: 'codCliente', label: 'Cliente (cód.)', icon: Users },
  { id: 'solicitante', label: 'Solicitante', icon: Users },
  { id: 'motivo', label: 'Motivo', icon: BookOpen },
  { id: 'tecnico', label: 'Técnico', icon: Wrench },
  { id: 'codTecnico', label: 'Técnico (cód.)', icon: Wrench },
  { id: 'condicaoFinal', label: 'Condição final', icon: CheckCircle2 },
  { id: 'fechamento', label: 'Fechamento', icon: CalendarCheck },
  { id: 'fimAtendimento', label: 'Fim atendimento', icon: CalendarCheck },
  { id: 'horaFim', label: 'Fim atendimento (horário)', icon: Clock },
  { id: 'laudo', label: 'Laudo', icon: BookOpen },
  { id: 'defeito', label: 'Defeito', icon: AlertCircle },
  { id: 'obsDefeito', label: 'Defeito (obs.)', icon: AlertCircle },
  { id: 'contrato', label: 'Contrato', icon: FileText },
  { id: 'contratoClassif', label: 'Contrato (classif.)', icon: FileText },
  { id: 'equipamento', label: 'Equipamento', icon: Package },
  { id: 'equipamentoResumo', label: 'Equipamento (resumo)', icon: Package },
  { id: 'serie', label: 'Série', icon: Hash },
  { id: 'patrimonio', label: 'Patrimônio', icon: Hash },
  { id: 'contadorA4Pb', label: 'Contador (A4 P&B)', icon: Gauge },
  { id: 'contadorA4Cor', label: 'Contador (A4 Cor)', icon: Gauge },
  { id: 'contadorDig', label: 'Contador (Dig.)', icon: Gauge },
  { id: 'contadorA3Pb', label: 'Contador (A3 P&B)', icon: Gauge },
  { id: 'contadorA3Cor', label: 'Contador (A3 Cor)', icon: Gauge },
  { id: 'inicioAtendimento', label: 'Início atendimento', icon: CalendarDays },
  { id: 'horaInicio', label: 'Início atendimento (horário)', icon: Clock },
  { id: 'deslocamento', label: 'Deslocamento', icon: Clock },
  { id: 'tempoProduzido', label: 'Tempo produzido', icon: Clock },
  { id: 'area', label: 'Área', icon: MapPin },
  { id: 'areaAbreviada', label: 'Área (abreviada)', icon: MapPin },
  { id: 'coordenador', label: 'Coordenador', icon: UserCheck },
  { id: 'status', label: 'Status', icon: Activity },
  { id: 'codStatus', label: 'Status (cód.)', icon: Activity },
  { id: 'logradouro', label: 'Logradouro', icon: MapPin },
  { id: 'localizacao', label: 'Local Interno', icon: MapPin },
  { id: 'bairro', label: 'Bairro', icon: MapPin },
  { id: 'cidade', label: 'Cidade', icon: MapPin },
  { id: 'uf', label: 'UF', icon: MapPin },
  { id: 'cep', label: 'CEP', icon: MapPin },
  { id: 'telefone1', label: 'Fone 1', icon: Phone },
  { id: 'telefone2', label: 'Fone 2', icon: Phone },
  { id: 'whatsapp', label: 'WhatsApp', icon: Phone },
  { id: 'email', label: 'E-mail', icon: Mail },
  /** cutoverOnly: só aparece para cliente com cutover (OS nativa); OS do ERP ficam sem valor. */
  { id: 'retornos', label: 'Retornos', icon: RotateCcw, cutoverOnly: true },
  { id: 'ultimoRetorno', label: 'Último retorno', icon: CalendarDays, cutoverOnly: true },
  /** Com "Ciclo" o relatório passa a uma linha por atendimento (Original, Retorno 1…) da OS nativa. */
  { id: 'ciclo', label: 'Ciclo (por atendimento)', icon: RotateCcw, cutoverOnly: true },
  { id: 'reincidencia', label: 'Reincidência', icon: AlertCircle, cutoverOnly: true },
];

/** Coluna que muda a granularidade da consulta (recarrega ao incluir/remover). */
export const CHAMADOS_CICLO_COLUMN_KEY = 'chamados_tecnicos:ciclo';
